import { getLodop } from '../../common/js/LodopFuncs'
import { BaseUrl } from '../../api/api'

var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};

// 获取本地缓存的打印信息
const _getPrintInfo = printName => {
  let printObject = window.localStorage.getItem('printInfo')
  if (printObject) {
    printObject = JSON.parse(printObject)
    return printObject[printName].Name
  }
  return null
}

export default {
    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {


        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y': return padding(date.getFullYear(), $0.length);
                    case 'M': return padding(date.getMonth() + 1, $0.length);
                    case 'd': return padding(date.getDate(), $0.length);
                    case 'w': return date.getDay() + 1;
                    case 'h': return padding(date.getHours(), $0.length);
                    case 'm': return padding(date.getMinutes(), $0.length);
                    case 's': return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y': _date.setFullYear(_int); break;
                        case 'M': _date.setMonth(_int - 1); break;
                        case 'd': _date.setDate(_int); break;
                        case 'h': _date.setHours(_int); break;
                        case 'm': _date.setMinutes(_int); break;
                        case 's': _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        }

    },
    //导出条码数据
    exportData: {

    },
    // 调用条码打印
    async LODOPrint (_this, PDFURL, width, height, printType) {
        try {
            let w, h
            w = width ? width : 1000
            h = height ? height : 2000
            PDFURL = BaseUrl.replace('https', 'http') + PDFURL
            // 获取指定的打印机名称
            const printName = _getPrintInfo(printType)
            console.log('printName', printName)

            // 打印机相关操作
            let LODOP = getLodop()
            LODOP.PRINT_INIT('')
            // 判断本地是否有符合命名的打印机
            let printStatus = true
            const printLen = LODOP.GET_PRINTER_COUNT()
            const printNameList = []
            for (let i = 0; i < printLen; i++) {
              printNameList.push(LODOP.GET_PRINTER_NAME(i))
            }
            console.log('printNameList', printNameList)
            if (printNameList.findIndex(p => p === printName) === -1) {
              // 未检测到符合命名的打印机，询问是否使用默认打印机
              try {
                await _this.$confirm('未检测到符合命名的打印机，是否使用默认打印机？', '提示', {
                  confirmButtonText: '使用默认打印机',
                  cancelButtonText: '取消操作',
                  type: 'warning'
                })
                LODOP.SET_PRINTER_INDEX(0)
              } catch (err) {
                printStatus = false
              }
            } else {
              // 有符合命名的打印机，设置指定的打印机
              console.log('LODOP.SET_PRINTER_INDEX(printName)', printName)
              LODOP.SET_PRINTER_INDEX(printName)
            }
            if (!printStatus) return
            LODOP.SET_PRINT_PAGESIZE(1, w, h, '')
            LODOP.ADD_PRINT_PDF(0, 0, '100%', '100%', PDFURL)
            LODOP.PRINT()
        }
        catch (e) {
            _this.$message({
                message: `LODOP打印控件异常或没有安装: ${e}`,
                type: 'error'
            })
        }
    },
    //下载文件默认根目录
    baseUrl: function(url){
        return "" + url
    },
    // 判断token是否过期
    expireToken (data) {
        if (data.Error && data.Error.DataID === 401) {
          return true
        } else {
          return false
        }
      },
    // 错误提示信息
    error: function(_this, data) {
        _this.$message({
          message: data.Message,
          type: 'error'
        });
        if (this.expireToken(data)) {
          _this.$router.push('/login')
        }
    }

};



// WEBPACK FOOTER //
// ./src/common/js/util.js